import { createRouter, createWebHistory } from 'vue-router'


const routes = [
  {
    path: '/',
    name: 'call',
    component: () => import(/* webpackChunkName: "about" */ '../views/CallList.vue'),
    meta: { requiresAuth: true }, // 需要登录
  },
  {
    path: '/customer',
    name: 'customer',
    component: () => import(/* webpackChunkName: "about" */ '../views/Customer.vue'),
    meta: { requiresAuth: true }, // 需要登录
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
   
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局导航守卫
router.beforeEach((to, from, next) => {
  console.log("Navigating to:", to.fullPath)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    var token = localStorage.getItem("token");
    // 如果页面需要认证且用户未登录，重定向到登录页面
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 将用户想去的页面保存在 query 中，登录后可以跳回
      });
    } else {
      next(); // 用户已登录，继续访问
    }
  } else {
    next(); // 不需要认证的页面，直接访问
  }
});

export default router
